import { Scene } from '../engine/scene';
import { getContext } from '../engine/context';

/**
 * Boot — immediately hands off to PreloadScene. Exists for symmetry with the
 * original 8-scene structure; a future pre-asset initialization (font loading,
 * locale detection) would live here.
 */
export class BootScene extends Scene {
  async onEnter(): Promise<void> {
    getContext().sceneManager.start('PreloadScene');
  }
}
